import React, { useEffect, useState } from 'react';
import { Icon } from '@iconify/react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { GetTagListForEdit, GetTagListForEditBS, GetTagListForEditGA, GetTagListForEditRL, PostTAg, PostTAgBS, PostTAgGA, PostTAgRL, SittingsListBasedOnSession, SubmitSittingsEdit } from '../../Services/allApi';

function EditOrAddTags({ handleCloseModalSS, videoId, whichPage }) {
    const [currentEntry, setCurrentEntry] = useState({
        key: '',
        value: '',
    });
    const [entryList, setEntryList] = useState([]);
    useEffect(() => {
        console.log(videoId);
        getListOfTags()
    }, [videoId])
    // get list of tags initially
    const getListOfTags = async () => {
        const token = sessionStorage.getItem('access_token');
        const reqHeader = {
            "Content-Type": "application/json",
            "Authorization": `${token}`
        };
        var res
        // identify which api to be called for updating tags,descision taken based on a string passed in 'whichPage'
        if (whichPage == 'ga') {
            res = await GetTagListForEditGA(videoId, reqHeader)
        }
        else if (whichPage == 'bs') {
            res = await GetTagListForEditBS(videoId, reqHeader)
        }
        else if (whichPage == 'rl') {
            res = await GetTagListForEditRL(videoId, reqHeader)
        }
        else {
            res = await GetTagListForEdit(videoId, reqHeader)
        }
        console.log(res);
        setEntryList(res?.data?.data)
    }

    // on typing in the text fields it pass the field ad value and store it to entryList on add
    const handleInputChangeSittings = (field, value) => {
        setCurrentEntry({
            ...currentEntry,
            [field]: value
        });
    };
    // when adding an entry it will push to 'currentEntry' and clears the input fields
    const handleAddEntry = () => {
        if (currentEntry.key && currentEntry.value) {
            setEntryList([...entryList, currentEntry]);
            setCurrentEntry({
                key: '',
                value: ''
            });
        } else {
            toast.warning("Fill the form completely to add");
        }
    };
    // on changing the tags fetched and listed by api it will store to the state as it is a new entry
    const handleInputChangeListSittings = (index, field, value) => {
        const newEntryList = [...entryList];
        newEntryList[index][field] = value;
        setEntryList(newEntryList);
    };
    // remove an entry 
    const handleRemoveEntry = (index) => {
        const newEntryList = entryList.filter((_, i) => i !== index);
        setEntryList(newEntryList);
    };
    // API to submit tags
    const handleSubmit = async () => {
        const token = sessionStorage.getItem('access_token');
        const reqHeader = {
            "Content-Type": "application/json",
            "Authorization": `${token}`
        };
        // Re arrangin object format to pass to api
        const modifiedSittingsList = {
            video_id: videoId,
            video_tags: entryList.map(item => ({
                key: item.key,
                value: item.value,
            }))
        };
        // const currentSession = detailsTable?.session_id;
        console.log(JSON.stringify(modifiedSittingsList, null, 2));
        var res
        if (whichPage == 'ga') {
            res = await PostTAgGA(modifiedSittingsList, reqHeader);
        }
        else if (whichPage == 'bs') {
            res = await PostTAgBS(modifiedSittingsList, reqHeader);
        }
        else if (whichPage == 'rl') {
            res = await PostTAgRL(modifiedSittingsList, reqHeader);
        }
        else {
            res = await PostTAg(modifiedSittingsList, reqHeader);
        }
        if (res.status == 200) {
            handleCloseModalSS()
            alert("Tag added successfully")
        }
        else {
            toast
                .error(res?.response?.data?.message ?? "There was an error adding tags")
        }
    };

    return (
        <>
            <div className='flex w-full h-full flex-row' style={{ height: '86vh' }}>
                <div className='w-full flex items-center flex-col overflow-y-scroll overflow-x-hidden' style={{ height: '87vh' }}>
                    <div className='flex justify-end items-start w-full pb-1'><div onClick={handleCloseModalSS} className='flex justify-center items-center h-8 w-14 rounded border border-red-500 hover:bg-red-500 hover:text-white transform duration-500 ease-in-out cursor-pointer text-red-500'><Icon icon="iconamoon:close" className='text-2xl' /></div></div>
                    <div className='flex flex-row justify-center flex-wrap ms-5 me-5 gap-1 w-full '>
                        <div className='flex flex-col w-full gap-5'>
                            <div className='bg-success px-4 py-2 rounded border'>
                                <h3 className='text-blue-700 text-xl font-bold mb-4 text-center'>Add / Edit Tags</h3>
                                <div className='flex flex-row justify-center flex-wrap mb-5'>
                                    <div className='w-3/12 flex flex-col me-5'>
                                        <label htmlFor="sdate">Tag key</label>
                                        <input
                                            type='text'
                                            value={currentEntry.key}
                                            onChange={(e) => handleInputChangeSittings('key', e.target.value)}
                                            className='w-full h-10 rounded-lg border border-gray-700 px-2'
                                        />
                                    </div>
                                    <div className='flex flex-col w-3/12'>
                                        <label>Tag value</label>
                                        <input
                                            type="text"
                                            value={currentEntry.value}
                                            onChange={(e) => handleInputChangeSittings('value', e.target.value)}
                                            className='w-full h-10 rounded-lg'
                                            style={{ border: '1px solid #384D6C' }}
                                        />
                                    </div>
                                    <div className='w-2/12 flex flex-col ms-5'>
                                        <label style={{ visibility: 'hidden' }}>Add</label>
                                        <button className='w-full py-2 rounded-lg bg-green-500 text-white mb-3' onClick={handleAddEntry}>
                                            Add
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className='w-full flex flex-col gap-4 mt-4'>
                        {entryList?.map((entry, index) => (
                            <div key={index} className='bg-gray-200 px-4 py-2 rounded border'>
                                <h3 className='text-gray-700 text-sm text-left'>No {index + 1}</h3>
                                <div className='flex flex-row justify-center flex-wrap mb-1'>
                                    <div className='w-3/12 flex flex-col me-5'>
                                        <label>Tag key</label>
                                        <input
                                            type='text'
                                            value={entry.key}
                                            onChange={(e) => handleInputChangeListSittings(index, 'key', e.target.value)}
                                            className='w-full h-10 rounded-lg border border-gray-700 px-2'
                                        />
                                    </div>

                                    <div className='flex flex-col w-3/12'>
                                        <label>Tag value</label>
                                        <input
                                            type="text"
                                            value={entry.value}
                                            onChange={(e) => handleInputChangeListSittings(index, 'value', e.target.value)}
                                            className='w-full h-10 rounded-lg'
                                            style={{ border: '1px solid #384D6C' }}
                                        />
                                    </div>

                                    <div className='w-2/12 flex flex-col ms-5'>
                                        <label style={{ visibility: 'hidden' }}>Remove</label>
                                        <button className='w-full py-2 rounded-lg bg-red-500 text-white mb-3' onClick={() => handleRemoveEntry(index)}>
                                            Remove
                                        </button>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>

                    <div className='flex flex-row justify-center gap-5 w-full'>
                        {entryList?.length > 0 && (
                            <div className='w-2/12'>
                                <button className='w-full py-2 mt-20 text-white rounded-full bg-primary' onClick={handleSubmit}>
                                    Submit
                                </button>
                            </div>
                        )}

                        <div className='w-2/12'>
                            <button className='w-full py-2 mt-20 rounded-full text-red-500 bg-success border' onClick={handleCloseModalSS}>
                                Cancel
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <ToastContainer
                position="top-center"
                autoClose={4000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                draggable
                pauseOnHover
                theme="light"
            />
        </>
    );
}

export default EditOrAddTags;
